export const APPLICATION_STATUS_LABELS = {
    submitted: 'Submitted',
    auto_screened: 'Passed screening',
    screened_out: 'Did not meet eligibility',
    shortlisted: 'Shortlisted',
    due_diligence: 'In due diligence',
    recommended: 'Recommended to board',
    board_pending: 'Deferred by board',
    approved: 'Approved by board',
    declined: 'Declined',
};
/** What the applicant sees. Honest, and no internal vocabulary. */
export const APPLICATION_STATUS_APPLICANT = {
    submitted: 'Received',
    auto_screened: 'Received and under review',
    screened_out: 'Did not meet the eligibility criteria',
    shortlisted: 'Under review',
    due_diligence: 'Under review',
    recommended: 'With the decision-makers',
    board_pending: 'With the decision-makers',
    approved: 'Approved',
    declined: 'Not successful this time',
};
export const GRANT_STATUS_LABELS = {
    prospect: 'Prospect',
    qualifying: 'Qualifying',
    applying: 'Preparing application',
    submitted: 'Submitted',
    awarded: 'Awarded',
    active: 'Active',
    closing: 'Closing out',
    closed: 'Closed',
    declined: 'Declined',
};
export const DISBURSEMENT_STATUS_LABELS = {
    draft: 'Draft',
    pending_approval: 'Awaiting approval',
    approved: 'Approved',
    exported: 'Sent to bank',
    paid: 'Paid',
    cancelled: 'Cancelled',
};
export const EVIDENCE_STATUS_LABELS = {
    pending: 'Awaiting validation',
    validated: 'Validated',
    queried: 'Queried',
    rejected: 'Rejected',
};
export const CASE_HEALTH_LABELS = {
    green: 'On track',
    amber: 'Needs attention',
    red: 'At risk',
};
export const REPORT_STATUS_LABELS = {
    requested: 'Requested',
    submitted: 'Submitted, awaiting review',
    accepted: 'Accepted',
};
/**
 * A tranche's status as a person reads it.
 *
 * `released` is written by approveDisbursement when the second person
 * approves the batch, which is before the bank file is sent and before
 * anyone has paid it. It used to read "Paid", while the runway and the
 * SED register wait for the batch's Mark paid before they treat the money
 * as gone, so the grant said a grantee had been paid on the day the
 * payment was only approved. Whether the bank has paid is the batch's to
 * say, on the Payments page.
 */
export function trancheLabel(status, direction = 'outgoing') {
    if (direction === 'incoming') {
        return status === 'received' ? 'Received' : 'Expected';
    }
    const map = {
        pending_conditions: 'Awaiting conditions',
        evidence_submitted: 'Evidence submitted',
        cleared: 'Cleared for payment',
        released: 'Approved for payment',
        withheld: 'Withheld',
        received: 'Received',
    };
    return map[status] ?? status;
}
